import { isFeatureFlagEnabled } from '@/composables/feature-flags'
import { getAuthToken } from '@/services/auth-token'

function guardLogin() {
  if (!isFeatureFlagEnabled('api_login')) {
    return { name: 'SettingsSignOut' }
  }
  if (getAuthToken()) {
    return { name: 'Home' }
  }
  return true
}

function guardNativeOnboarding() {
  if (getAuthToken()) {
    return { name: 'Home' }
  }
  return true
}

const routesAuth = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      title: 'Log in',
      public: true
    },
    beforeEnter: [guardLogin]
  },
  {
    path: '/native-onboarding',
    name: 'NativeOnboarding',
    component: () => import('@/views/auth/NativeOnboardingView.vue'),
    meta: {
      title: 'Welcome',
      public: true
    },
    beforeEnter: [guardNativeOnboarding]
  }
]

export default routesAuth
